<style lang="less" scoped>
/deep/.el-tabs__nav>.el-tabs__item{padding: 0px !important;}
/deep/.el-tabs__item {width: 120px;font-size: 14px;padding: 0px;}
</style>
<template>
<div>
  <el-tabs v-model="editableTabsValue" type="card">
    <el-tab-pane label='咨询内容列表' name='1'>
      <ZxserverList :userdata='userdata'></ZxserverList>
    </el-tab-pane>
  </el-tabs>
</div>
</template>
<script>
/**
 * 李旭
 * 后台咨询管理页面
 */
import ZxserverList from '../assembly/ZxserverList.vue'
import {mapState} from 'vuex'
export default {
  props: ['userData'],
  components: {
    ZxserverList
  },
  data()
  {
    return {
      editableTabsValue: '1',
      userdata: this.userData
    }
  },
  computed:
  {
    ...mapState({
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    IsLb:
    {
      handler(nval, oval)
      {
        this.editableTabsValue = nval
      },
      deep: true,
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/ZxServer.vue